import React from "react";

export function Hide({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}): React.ReactElement {
  return (
    <svg
      height="9pt"
      viewBox="0 0 384 384"
      width="9pt"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
      fill="currentColor"
    >
      <g>
        <path d="m192 384c105.863281 0 192-86.128906 192-192 0-51.328125-19.960938-99.550781-56.207031-135.792969-36.25-36.246093-84.464844-56.207031-135.792969-56.207031-105.871094 0-192 86.128906-192 192 0 51.328125 19.960938 99.550781 56.207031 135.792969 36.242188 36.246093 84.464844 56.207031 135.792969 56.207031zm0-32c-37.390625 0-72.800781-12.710938-101.296875-36.078125l225.21875-225.21875c23.367187 28.496094 36.078125 63.90625 36.078125 101.296875 0 88.222656-71.777344 160-160 160zm0-320c37.382812 0 72.800781 12.710938 101.289062 36.078125l-225.210937 225.21875c-23.367187-28.496094-36.078125-63.90625-36.078125-101.296875 0-88.222656 71.777344-160 160-160zm0 0" />
      </g>
    </svg>
  );
}
